import React, { useState } from "react";
import CardGrid from "../components/CardGrid";
import CategorySelect from "../components/CategorySelect";
import CreateItemModal from "../components/CreateItemModal";
import CustomFooter from "../components/CustomFooter";
import CustomNavbar from "../components/CustomNavbar";
import ViewItemModal from "../components/ViewItemModal";

export default function Dashboard() {
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showView, setShowView] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [activeCategory, setActiveCategory] = useState("lost");

  let categories_names = {
    shirts: "T-Shirts und Trikots",
    longsleeves: "Lange Oberteile",
    shorts: "Kurze Hosen",
    trousers: "Lange Hosen",
    others: "Fußballschuhe, Bälle, Sonstiges...",
    lost: "Fundsachen",
  };

  return (
    <div>
      <CustomNavbar
        loading={loading}
        setLoading={setLoading}
        setShowCreate={setShowCreate}
        isPrivate={false}
      />

      <CategorySelect
        activeCategory={activeCategory}
        setActiveCategory={setActiveCategory}
      />

      <h1
        className="d-flex justify-content-center mt-sm-5 mt-4"
        style={{
          marginLeft: "12%",
          marginRight: "12%",
          borderBottomStyle: "solid",
          borderWidth: "3px",
          borderColor: "#dfdfdf",
          height: "70px",
        }}
      >
        {categories_names[activeCategory]}
      </h1>

      <CardGrid
        loading={loading}
        setLoading={setLoading}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        showView={showView}
        setShowView={setShowView}
        uid={null}
        category={activeCategory}
        isPrivate={false}
      />

      <CreateItemModal
        edit={false}
        file={null}
        showCreate={showCreate}
        setShowCreate={setShowCreate}
        loading={loading}
        setLoading={setLoading}
      />
      <ViewItemModal
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        showView={showView}
        setShowView={setShowView}
      />
      <CustomFooter />
    </div>
  );
}
